var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", {
        attrs: {
          title: "Manage Guidelines",
          icon: "assignment",
          subtitle: _vm.subtitle,
        },
      }),
      _vm._v(" "),
      _c(
        "Subheader",
        {
          attrs: { title: "Guidelines", search: "guidelines" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: {
                dark: "",
                color: "add",
                to: {
                  name: "guidelinesDetail",
                  params: { name: _vm.AddGuidelineActionName },
                },
              },
            },
            [
              _c("v-icon", [_vm._v("add")]),
              _vm._v(_vm._s(_vm.$t("Button.AddaNewGuideline")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.GuidelineList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            _vm._s(props.item.GuidelineLongName) +
                              " (" +
                              _vm._s(props.item.GuidelineName) +
                              ")"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.Category)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.Medias)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            _vm._s(
                              props.item.LastModifiedDateTime != null
                                ? _vm.formatDate(
                                    props.item.LastModifiedDateTime,
                                    _vm.prettyDateTimeFormat
                                  )
                                : ""
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-right",
                            staticStyle: { display: "flex" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "warning",
                                  to: {
                                    name: "guidelinesDetail",
                                    params: { name: props.item.GuidelineName },
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v("edit"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Edit")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "error" },
                                on: {
                                  click: function ($event) {
                                    return _vm.showDeleteGuidelineDialog(
                                      props.item
                                    )
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v("delete_forever"),
                                ]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("Button.Delete")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.delDialog,
            callback: function ($$v) {
              _vm.delDialog = $$v
            },
            expression: "delDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Delete Guideline")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDeleteGuidelineDialog()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("GuidelineManagement.deleteTitleMsg", {
                        longName: _vm.delGuideline.GuidelineLongName,
                        shortName: _vm.delGuideline.GuidelineName,
                      })
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$t("GuidelineManagement.deleteMsg"))),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "delete", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.agreeDelete()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("Button.DELETE_GUIDELINE")) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.closeDeleteGuidelineDialog()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: {
                color: _vm.snackColor,
                timeout: null,
                top: "",
                "auto-height": "",
              },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }